module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/event-05-2ac9e51c4e64136e726cdc82b2d8a834.jpg";